import { render } from "./ListaOrdiniSenzaCalendario.vue?vue&type=template&id=a4fb88b2"
import script from "./ListaOrdiniSenzaCalendario.vue?vue&type=script&lang=js"
export * from "./ListaOrdiniSenzaCalendario.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__